import '../../../../styles/index.css'
import './OfertadoPor.css';
import Terabyte from '../../../../assets/img/Terabyte.svg';
import Kabum from '../../../../assets/img/Kabum.svg';
import Pichau from '../../../../assets/img/Pichau.svg';

function OfertadoPor({ loja }) {

  const retornaFotoLoja = (loja) => {

    if (loja === 'Terabyte') {
      return Terabyte;
    }

    if (loja === 'Kabum') {
      return Kabum;
    }

    if (loja === 'Pichau') {
      return Pichau;
    }

  }

  return (
    <div className='ofertadoDiv'>
      <p className='c1 '>Ofertado Por:</p>
      <div>
        <img src={retornaFotoLoja(loja)} alt="" data-cy="ofertado-por-loja-imagem"/>
      </div>
      <p className='bt3'>{loja}</p>
    </div>
  );

}

export default OfertadoPor;
